'use strict';
var populations = document.querySelectorAll('.population');
var numbers = [];
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = populations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var el = _step.value;
        var text = el.textContent;
        var number = Number(text.replaceAll(',', ''));
        numbers.push(number);
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
var total = numbers.reduce(function(sum, num) {
    return sum + num;
}, 0);
var average = Math.round(total / numbers.length);
document.querySelector('.total-population').textContent = total.toLocaleString();
document.querySelector('.average-population').textContent = average.toLocaleString();

//# sourceMappingURL=js_get_data_DOM.ee18947d.js.map
